import { Card as NextCard, Spacer } from '@nextui-org/react';
import Link from 'next/link';
import IconSpin from './IconSpin';
import TextWithHonorifics from './TextWithHonorifics';

export function ChapterCard({
  chapter,
  name,
  bookId,
  bookSectionNumber,
  chapterNumber,
}: {
  chapter?: any;
  name?: String;
  bookId?: any;
  bookSectionNumber?: any;
  chapterNumber?: any;
}) {
  return (
    <Link className="m-2" href={`/chapter/${bookId}/${bookSectionNumber}/${chapterNumber}`} scroll={false}>
      <NextCard isHoverable isPressable className="md:my-4 my-2 w-full h-40" variant="shadow">
        <div className="card-body">
          <h2 className="card-title">Chapter {chapter || '1'}</h2>
          <div className="h-full line-clamp-3">
            <TextWithHonorifics text={name || ''} />
          </div>
        </div>
      </NextCard>
    </Link>
  );
}

export function BookSectionCard({
  sectionNumber,
  name,
  onClick,
  isOpen,
}: {
  sectionNumber?: any;
  name?: String;
  onClick?: any;
  isOpen?: boolean;
}) {
  return (
    <NextCard
      isPressable
      className="md:my-4 my-2 h-24 bg-stone-200 dark:bg-slate-600 flex flex-row"
      role="banner"
      variant="flat"
      onPress={() => {
        onClick ? onClick() : null;
        console.log('l');
      }}
    >
      <h2 className="md:text-2xl text-xl font-extrabold text-center m-auto px-2 flex-grow">
        {name?.toLowerCase() == 'content' || name?.toLowerCase().trim() == ''
          ? `Section ${sectionNumber}`
          : `${sectionNumber} | ${name}`}
      </h2>
      <IconSpin className="m-auto" isOpen={!!isOpen} />
      <Spacer x={1} />
    </NextCard>
  );
}
